import type { Recommendation } from '../../data/schemas';
import type { RecommendationGroup } from '../../types/ids';
import type { ActionPlan } from '../../types/result';
import type { RankedRecommendationId } from './collectRecommendations';

/**
 * Gruppiert gesammelte Empfehlungen nach `first`/`next`/`later` (Abschnitt 21.4) und begrenzt
 * jede Gruppe auf die konfigurierte Höchstzahl (Abschnitt 21.5: kritische Empfehlungen zuerst).
 */
export function prioritizeRecommendations(
  ranked: readonly RankedRecommendationId[],
  catalog: readonly Recommendation[],
  maximumPerGroup: number,
): ActionPlan {
  const catalogById = new Map(catalog.map((recommendation) => [recommendation.id, recommendation]));
  const groups: Record<RecommendationGroup, RankedRecommendationId[]> = {
    first: [],
    next: [],
    later: [],
  };

  for (const item of ranked) {
    const recommendation = catalogById.get(item.id);
    if (!recommendation) continue;
    groups[recommendation.defaultPriority].push(item);
  }

  const actionPlan: ActionPlan = { first: [], next: [], later: [] };
  for (const group of ['first', 'next', 'later'] as const) {
    actionPlan[group] = groups[group]
      .slice()
      .sort((a, b) => a.rank - b.rank)
      .slice(0, maximumPerGroup)
      .map((item) => item.id);
  }
  return actionPlan;
}
